// let url = "http://localhost:8080/MROfficialWebsite/";
let url = "";

// let url = "https://www.bj-mrkj.com/"

let loading = {
    lock: true,
    text: '数据加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
}

var obj = {
    url: url,
    token: null,
    loading: loading,
    htmlContentVueUrl: '/#/templateList',
    languageMap: null
}
export default obj;